import { render } from "./FlowyNavMenu.vue?vue&type=template&id=4d48710a&scoped=true"
import script from "./FlowyNavMenu.vue?vue&type=script&lang=js"
export * from "./FlowyNavMenu.vue?vue&type=script&lang=js"

import "./FlowyNavMenu.vue?vue&type=style&index=0&id=4d48710a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d48710a"]])

export default __exports__